import React from 'react';

import { IconButton } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import { ReactComponent as AddIcon } from 'pages/Teachers/AssignmentsList/assets/add.svg';
import { ReactComponent as CameraIcon } from 'pages/Teachers/AssignmentsList/assets/camera.svg';
import { MASTERY_LEVELS } from 'pages/Teachers/ClassroomInsights/constants';

import styles from './styles.module.scss';

const OverallPerformanceCard = ({
  show,
  onUploadAssignment,
  onAddAssignment,
  intervene,
  support,
  celebrate,
  dataIsLoading
}) => (
  <section className={styles.summaryCard}>
    {show && (
      <div className={styles.metricVisualLayout}>
        <div className={styles.metricContainer}>
          <div className={styles.metricTextHeader}>
            {/* <span className={styles.metricPercentage}>80%</span> */}
            <span className={styles.metricDescriptionLabel}>
              Overall across all assignments
            </span>
          </div>

          <div className={styles.masteryIndicatorLegend}>
            <div className={styles.legendElement}>
              <span
                className={`${styles.statusIndicatorDot} ${styles.bgIntervene}`}
              />
              {MASTERY_LEVELS.INTERVENE}
            </div>
            <div className={styles.legendElement}>
              <span
                className={`${styles.statusIndicatorDot} ${styles.bgSupport}`}
              />
              {MASTERY_LEVELS.SUPPORT}
            </div>
            <div className={styles.legendElement}>
              <span
                className={`${styles.statusIndicatorDot} ${styles.bgCelebrate}`}
              />
              {MASTERY_LEVELS.CELEBRATE}
            </div>
          </div>
        </div>

        {dataIsLoading ? (
          <div className={styles.loadingSkeleton}>
            <Skeleton animation="wave" />
          </div>
        ) : (
          <div className={styles.stackedDistributionBar}>
            <div
              className={styles.segmentIntervene}
              style={{ width: `${intervene}%` }}
            >
              {intervene}%
            </div>
            <div
              className={styles.segmentSupport}
              style={{ width: `${support}%` }}
            >
              {support}%
            </div>
            <div
              className={styles.segmentCelebrate}
              style={{ width: `${celebrate}%` }}
            >
              {celebrate}%
            </div>
          </div>
        )}
      </div>
    )}

    <div className={styles.summaryQuickActions}>
      <IconButton className={styles.addButton} onClick={onAddAssignment}>
        <AddIcon fontSize="large" />
      </IconButton>
      <IconButton className={styles.addButton} onClick={onUploadAssignment}>
        <CameraIcon fontSize="large" />
      </IconButton>
    </div>
  </section>
);

export default OverallPerformanceCard;
